import { z } from "zod";

/**
 * Agenda preset view options
 *
 * @property viewDropIns - Whether to view drop-ins in the agenda columns
 * @property viewBlockings - Whether to view blockings in the agenda columns
 * @property viewExtras - Whether to view extras in the agenda columns
 */
const agendaPreset_viewOptionsZodObject = z.object({
    viewDropIns: z.boolean().default(true),
    viewBlockings: z.boolean().default(true),
    viewExtras: z.boolean().default(true),
});

/**
 * Agenda preset view options
 *
 * @property viewDropIns - Whether to view drop-ins in the agenda columns
 * @property viewBlockings - Whether to view blockings in the agenda columns
 * @property viewExtras - Whether to view extras in the agenda columns
 */
type AgendaPreset_ViewOptions = z.infer<
    typeof agendaPreset_viewOptionsZodObject
>;

export { agendaPreset_viewOptionsZodObject };
export type { AgendaPreset_ViewOptions };
